import { CommentState } from './comment.state';
import { LightPostModel } from '../../../shared/data/models/light-post.model';
import { PageInfoModel } from '../../../shared/data/models/page-info.model';

export interface PostState {
  post: LightPostModel;
  commentsState: CommentState[];
  commentCursor: PageInfoModel;
  showComments: boolean;

  // postLoading
  // postError
  postLoading: boolean;
  postError: string;

  commentLoading: boolean;
  commentError: string;

  postVoteLoading: boolean;
  postVoteError: string;

  // create comment states
  createCommentLoading: boolean;
  createCommentError: string;

  // favorite post
  favoritePostLoading: boolean;
  favoritePostError: string;

  // poll loading
  pollPostLoading: boolean;
  pollPostError: string;

  // this will be removed soon.
  deleted: boolean;
}

export const initialPostState: PostState = {
  post: null,
  postError: '',
  postLoading: false,
  commentsState: [],
  commentCursor: null,
  showComments: false,
  commentLoading: false,
  commentError: '',
  postVoteLoading: false,
  postVoteError: '',
  createCommentLoading: false,
  createCommentError: '',
  favoritePostLoading: false,
  favoritePostError: '',
  deleted: false,
  pollPostLoading: false,
  pollPostError: ''
};
